export function createAction(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            const prepared = prepareAction(...args);
            return {
                type,
                payload: prepared.payload,
                ...(prepared.meta !== undefined && { meta: prepared.meta }),
                ...(prepared.error !== undefined && { error: prepared.error }),
            };
        }
        return { type, payload: undefined };
    }
    actionCreator.type = type;
    actionCreator.match = (action) => action.type === type;
    actionCreator.toString = () => type;
    return actionCreator;
}
export function isAnyOf(...matchers) {
    return (action) => {
        return matchers.some((matcher) => {
            if ("match" in matcher && typeof matcher.match === "function") {
                return matcher.match(action);
            }
            if ("type" in matcher) {
                return action.type === matcher.type;
            }
            return false;
        });
    };
}
//# sourceMappingURL=actionUtils.js.map